import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #3b82f6 0, transparent 40%), radial-gradient(circle at 80% 70%, #6366f1 0, transparent 40%)" }} />
      <div className="relative w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="font-heading text-2xl font-extrabold text-white">Opera<span className="text-blue-500">Mind</span></span>
          <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 border border-slate-700 rounded px-1.5 py-0.5">Admin</span>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-slate-900 border border-slate-800 rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-slate-200 mb-1"><ShieldCheck className="h-5 w-5 text-blue-500" /><h1 className="font-heading text-xl font-bold">Admin Portal</h1></div>
          <p className="text-sm text-slate-500 mb-6">Restricted access — OperaMind staff only.</p>
          <div className="space-y-4">
            <div>
              <Label className="text-xs text-slate-400">Email</Label>
              <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="mt-1 bg-slate-800 border-slate-700 text-white" placeholder="admin@operamind.com" />
            </div>
            <div>
              <Label className="text-xs text-slate-400">Password</Label>
              <Input data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="mt-1 bg-slate-800 border-slate-700 text-white" placeholder="••••••••" />
            </div>
          </div>
          {err && <p data-testid="admin-login-error" className="text-sm text-red-400 mt-4">{err}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={busy} className="w-full mt-6 bg-blue-600 hover:bg-blue-700 gap-2 h-11">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4" /> Sign in</>}
          </Button>
        </form>
        <p className="text-center text-xs text-slate-600 mt-4">Not a customer login. Customers sign in at /login.</p>
      </div>
    </div>
  );
}
